export default __webpack_public_path__ + "static/media/seasonal-2.bcb873fa.jpg";